import React from "react";
import Refrigerants from "components/app/report/environment/refrigerant/Refrigerants";

type ScreenRefrigerantsProps = React.PropsWithChildren<{}>;

function ScreenRefrigerants(props: ScreenRefrigerantsProps) {
	return <Refrigerants />;
}

export default ScreenRefrigerants;
